import styled from "styled-components"

import {perkbox} from "@irati/ui/src/global/colors"

export default styled.div`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: ${perkbox.blue};
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.24);
`
